import { render, staticRenderFns } from "./Chairman.vue?vue&type=template&id=469bb359&scoped=true&"
import script from "./Chairman.vue?vue&type=script&lang=js&"
export * from "./Chairman.vue?vue&type=script&lang=js&"
import style0 from "./Chairman.vue?vue&type=style&index=0&id=469bb359&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469bb359",
  null
  
)

export default component.exports